import { DateTime, IANAZone } from 'luxon';

let activeTimeZone: string | null = null;

const isValidTimeZone = (timeZone: string) => IANAZone.isValidZone(timeZone);

const setActiveTimeZone = (timeZone: string | null | undefined) => {
  activeTimeZone = timeZone && isValidTimeZone(timeZone) ? timeZone : null;
};

const getExplicitUserTimeZone = () => activeTimeZone;

const getUserTimeZone = () => activeTimeZone ?? 'system';

const listTimeZones = () => {
  const supportedValuesOf = (Intl as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
  if (typeof supportedValuesOf !== 'function') {
    return [];
  }
  return [...supportedValuesOf('timeZone')].sort((a, b) => a.localeCompare(b));
};

const timeZoneLabel = (timeZone: string, now = DateTime.now()) => {
  const offset = now.setZone(timeZone).toFormat('ZZ');
  return `${timeZone.replace(/_/g, ' ')} (UTC${offset})`;
};

export {
  getExplicitUserTimeZone,
  getUserTimeZone,
  isValidTimeZone,
  listTimeZones,
  setActiveTimeZone,
  timeZoneLabel,
};
